import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanchakrushnaComponent } from './panchakrushna.component';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    PanchakrushnaComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  providers:[HttpClient]
})
export class PanchakrushnaModule{

 }

